import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.scss';

const TABLET_MIN = 540;
export const HERO_SHAPE_COLORS = {
  chili_jam: '#fd969b',
  burger_sauce: '#ffd4c1',
  lime: '#d0eb99',
};

export const SVG = {
  viewBox: {
    mobile: '0 0 335 404',
    tablet: '0 0 1060 592',
  },
  points: {
    mobile: '335,0 20.9,0 106.6,403 335,354.5',
    tablet: '1060,0 18.9,0 144.7,591.8 1060,397.2',
  },
};

/**
 * An abstract SVG shape to use as part of a hero section
 */
export default class HeroShape extends React.Component {
  state = {
    // assume we’re at tablet width until proven otherwise, since this prevents
    // the shape visibly ‘moving’ across the screen at desktop resolutions.
    isTabletWidth: true,
  };

  componentDidMount() {
    this.mediaQuery = window.matchMedia(`(min-width: ${TABLET_MIN}px)`);
    this.handleMediaChange(this.mediaQuery);
    this.mediaQuery.addListener(this.handleMediaChange);
  }

  componentWillUnmount() {
    this.mediaQuery.removeListener(this.handleMediaChange);
  }

  handleMediaChange = (mq) => {
    this.setState({ isTabletWidth: !!mq.matches });
  };

  shape = () => {
    const { color } = this.props;
    const { isTabletWidth } = this.state;
    const breakpoint = isTabletWidth ? 'tablet' : 'mobile';

    return (
      <svg
        viewBox={SVG.viewBox[breakpoint]}
        preserveAspectRatio="xMaxYMin meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon fill={`${HERO_SHAPE_COLORS[color]}`} points={SVG.points[breakpoint]} />
      </svg>
    );
  };

  backgroundSize = () => {
    const { isTabletWidth } = this.state;
    return isTabletWidth ? `auto ${TABLET_MIN}px` : 'auto';
  };

  render() {
    const { savedAddressCount, children } = this.props;
    const shape = ReactDOMServer.renderToString(this.shape());
    const outerClassNames = classnames(styles.outer, {
      [styles[`saved-addresses-${savedAddressCount}`]]: savedAddressCount > 0,
    });

    return (
      <header className={outerClassNames}>
        <div
          className={styles.backgroundFill}
          style={{
            backgroundImage: `url(data:image/svg+xml;utf8,${encodeURIComponent(shape)})`,
            backgroundSize: this.backgroundSize(),
          }}
        >
          {children}
        </div>
      </header>
    );
  }
}

HeroShape.propTypes = {
  /**
   * A named colour for the shape fill.
   */
  color: PropTypes.oneOf(Object.keys(HERO_SHAPE_COLORS)).isRequired,

  /**
   * Number of saved addresses being passed through to the address search /
   * location search child component, if any.
   */
  savedAddressCount: PropTypes.number,

  /**
   * Child elements for the header.
   */
  children: PropTypes.node.isRequired,
};

HeroShape.defaultProps = {
  savedAddressCount: 0,
};
